import { render, staticRenderFns } from "./LeavePageStatisticsTable.vue?vue&type=template&id=b77c62fe&scoped=true&"
import script from "./LeavePageStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./LeavePageStatisticsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77c62fe",
  null
  
)

export default component.exports